import { FormDrawer, FormDrawerContent, PagedMultiSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FormikErrors } from "formik";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { archivedEventService } from "../../../shared/api/event/archivedEventService";
import { getFullNameFromContactOption } from "../../../shared/select/ContactSelectField";
import { IContactOptionResource } from "../../../shared/types";

interface AddContactFormValues {
	contacts: IContactOptionResource[];
}

const emptyFormValues: AddContactFormValues = {
	contacts: [],
};

interface Props {
	open: boolean;
	onClose: () => void;
	onSubmit: (contacts: IContactOptionResource[]) => Promise<boolean>;
}

export const AddContactDrawer: FC<Props> = ({ open, onClose, onSubmit }) => {
	const { t } = useTranslation();
	const { eventId = "" } = useParams<"eventId">();

	const validate = useCallback(
		(formValues: AddContactFormValues) => {
			const errors: FormikErrors<AddContactFormValues> = {};

			if (formValues.contacts.length === 0) {
				errors.contacts = t("Required field");
			}

			return errors;
		},
		[t],
	);

	return (
		<FormDrawer
			open={open}
			onClose={onClose}
			title={t("Add contact")}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<PagedMultiSelectField
						{...props}
						name="contacts"
						label={t("Contacts")}
						fetchConfig={laravelSelectFetchConfig(archivedEventService.contactOptionsKey(eventId), (search, page) =>
							archivedEventService.contactOptions(eventId, search, page).then((r) => r.data),
						)}
						getLabel={getFullNameFromContactOption}
					/>
				</FormDrawerContent>
			)}
			initialValues={emptyFormValues}
			validate={validate}
			onSubmit={({ contacts }) => onSubmit(contacts)}
		/>
	);
};
